export function getPhotoBoxDownloadUrl(imageId?: number, imageUrl?: string): string | undefined {
    if (imageId !== undefined && imageId !== null) {
        return `/api/v1/servefile/${imageId}`;
    }

    return imageUrl;
}
